<template>
  <main class="modal-wrapper">
    <div class="modal">
      <TheInput
        v-model="unit.name"
        label="Име на звено"
        placeholder="Звено"
        icon="B"
      />

      <main class="input-wrap">
        <label class="input-label"
          >Служители в това звено (Отчетници всички обекти)</label
        >

        <div class="unit-workers">
          <section>
            <span class="sienit sienit--left">B</span>

            <button @click="showAddUsersModal = true">
              <span class="sienit">L</span>
              <p>ДОБАВИ СЛУЖИТЕЛИ</p>
            </button>
          </section>

          <section v-if="unit.workers">
            <p v-for="u of unit.workers" :key="u._id">{{ u.name }}</p>
          </section>
        </div>
      </main>

      <footer>
        <div class="switch-container">
          <label class="switch">
            <input type="checkbox" v-model="unit.isActive" />
            <span class="slider"></span>
          </label>
          <label>Активно звено</label>
        </div>

        <div class="btns">
          <button class="btn btn-new" @click.prevent="save">
            <span class="sienit">B</span>
            Запази
          </button>
          <button class="btn btn-close" @click.prevent="closeModal(false)">
            <span class="sienit">F</span>
            Отказ
          </button>
        </div>
      </footer>
    </div>

    <transition name="fade">
      <AddUsersModal
        v-if="showAddUsersModal"
        :incomingUsers="unit.workers || []"
        :usersType="'isAllProjectsReporter'"
        :unitID="unit._id"
      />
    </transition>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import log from "../mixins/log.js";
import TheInput from "../shared/TheInput.vue";
import AddUsersModal from "../shared/AddUsersModal.vue";
export default {
  mixins: [log],
  props: ["idToEdit"],
  components: {
    TheInput,
    AddUsersModal,
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      // ...
    ]),
  },
  data() {
    return {
      unit: { isActive: true },
      showAddUsersModal: false,
    };
  },
  methods: {
    async save() {
      if (!this.unit.name) {
        return this.$snotify.error("Въведете име на звеното!");
      }

      try {
        if (this.unit._id) {
          await this.$http.put(
            `${process.env.VUE_APP_BASE_URI}/units/${this.unit._id}`,
            this.unit
          );
        } else {
          await this.$http.post(
            `${process.env.VUE_APP_BASE_URI}/units`,
            this.unit
          );
        }

        this.$snotify.success("Успешно създадохте звено!");
        // this.newLog(
        //   "newUser",
        //   this.user.permissions.isWorker ? this.user.name : this.user.username
        // );
        this.closeModal(true);
      } catch (error) {
        if (error.response && error.response.data) {
          this.$snotify.error(error.response.data.error);
        } else {
          this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
        }
      }
    },
    closeModal(isEdited) {
      this.$emit("close", isEdited);
    },
    async getSpecificUnit(id) {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_BASE_URI}/units/${id}`
        );
        this.unit = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    closeAddUsersModal() {
      this.showAddUsersModal = false;
    },
    handleWorkers(arr) {
      this.unit.workers = []
      for(let u of arr) {
        this.unit.workers.push(u)
      }
      this.closeAddUsersModal();
    },
  },
  mounted() {
    document.body.classList.add("stop-scrolling");

    this.$on("saveAddUsersModal", this.handleWorkers);
    this.$on("closeAddUsersModal", this.closeAddUsersModal);

    if (this.idToEdit) {
      this.getSpecificUnit(this.idToEdit);
    }
  },
  destroyed() {
    document.body.classList.remove("stop-scrolling");
    this.$off("saveAddUsersModal");
    this.$off("closeAddUsersModal");
  },
};
</script>

<style scoped lang="scss">
.modal-wrapper {
  .modal {
    padding: 10px;
    max-width: 600px;

    .unit-workers {
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #d8d2bd;
      border-radius: 4px;
      flex-direction: column;
      display: flex;

      > section {
        align-items: center;
        display: flex;
        gap: 10px;
        position: relative;
        padding: 5px 0 5px 34px;

        .sienit--left {
          color: #8d3506;
          font-size: 16px;
          left: 10px;
          position: absolute;
          top: 50%;
          -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
        }

        &:last-of-type {
          align-items: flex-start;
          flex-direction: column;
          max-height: 200px;
          overflow: auto;
        }
      }

      button {
        align-items: center;
        background: black;
        border-radius: 20px;
        cursor: pointer;
        color: white;
        display: flex;
        gap: 10px;
        height: fit-content;
        padding: 5px 10px;
        width: fit-content;
      }
    }

    footer {
      display: flex;
      justify-content: space-between;
      padding-top: 10px;
    }
  }
}
@media screen and (max-width: 1000px) {
  .modal-wrapper {
    .modal {
      width: calc(100% - 10px);

      > footer {
        align-items: center;
        flex-direction: column;
        gap: 5px;
      }
    }
  }
}
</style>
